module.exports = __webpack_public_path__ + "static/media/Neuroimaging  - Graphic.1796fb2a.svg";